
const initialState = {
    payoutApprovalStages: [],
    loading: false,
    error: null,
};

const payoutApprovalStagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'PAYOUT_APPROVAL_STAGES_SUCCESS':
            return {
                ...state,
                payoutApprovalStages: action.payload,
                loading: false,
                error: null,
            };
        case 'PAYOUT_APPROVAL_STAGES_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

export default payoutApprovalStagesReducer;